(function(window1) {
    const isPrivacyShown = window1.localStorage.getItem("yohePrivacy");
    if (isPrivacyShown) return;
    const handleClick = (e)=>{
        e.preventDefault();
        window1.localStorage.setItem("yohePrivacy", true);
        document.querySelector(".cookies-container").classList.remove("active");
    };
    setTimeout(()=>{
        document.querySelector(".cookies-container").classList.add("active");
        document.querySelector(".cookies-container .close-icon").onclick = handleClick;
        document.querySelector(".cookies-container .button").onclick = handleClick;
    }, 1000);
})(window);

//# sourceMappingURL=index.d60c0a1f.js.map
